import {PATHS} from 'routes/constants';
import {usePath} from 'hooks';
import {useTranslation} from 'react-i18next';
import {LoginRow as Wrapper, LoginLink} from '../styled';

type Props = {
  isLogin: boolean;
};

const LoginRow = ({isLogin}: Props) => {
  const {t} = useTranslation();
  const {getFullPath} = usePath();
  const title = isLogin ? t('auth.dont_have_account') : t('auth.already_have_account');
  const label = isLogin ? t('auth.sign_up') : t('auth.login');
  const to = isLogin
    ? getFullPath(`${PATHS.auth.root}/${PATHS.auth.createAccount}`)
    : getFullPath(`${PATHS.auth.root}/${PATHS.auth.login}`);

  return (
    <Wrapper>
      <span>{title}</span>
      <LoginLink link label={label} to={to} />
    </Wrapper>
  );
};

export {LoginRow};
